export const localStorageKeys = {
  LANGUAGE: 'i18nextLng',
  HAS_SESSION: 'hasSession',
};
